import React from 'react';
import { Row, Col } from 'reactstrap';
import { DateTimeField } from '../DateTime';
import { formatDateBy, formatTime } from '../../utils/dates';

const ScreeningDatePicker = ({ screeningDate, setScreeningDate, minimumHours = 4, minimumHoursLabel = null }) => {
    // Helper to check if a date is valid
    const isValidDate = (date) => {
        return date instanceof Date && !isNaN(date.getTime());
    };

    // Calculate minimum date
    const addTimeToDate = (date, amount = 0, unit = 'hours') => {
        const result = new Date(date);
        if (unit === 'days') {
            result.setDate(result.getDate() + amount);
        } else {
            result.setHours(result.getHours() + amount);
        }
        return result;
    };

    const minimumScreeningDate = addTimeToDate(new Date(), minimumHours, 'hours');

    const isScreeningDateValid = () => {
        if (!screeningDate || !isValidDate(screeningDate)) return false;
        if (minimumHours === 0) return true;
        return Math.floor(screeningDate.getTime() / 60000) >= Math.floor(minimumScreeningDate.getTime() / 60000);
    };

    const showInvalid = Boolean(screeningDate) && !isScreeningDateValid();

    return (
        <>
            <Row>
                <Col className="mb-3">
                    <DateTimeField
                        value={screeningDate}
                        onChange={setScreeningDate}
                        step={15}
                        // Only constrain when there is a lead time to enforce —
                        // with minimumHours 0 any date stays selectable.
                        minDate={minimumHours > 0 ? minimumScreeningDate : undefined}
                        invalid={showInvalid}
                        datePlaceholder="Screening date"
                    />
                </Col>
            </Row>
            <Row>
                {minimumHours > 0 && (
                    <Col>
                        <span className="fas fa-circle-info me-2" />
                        {minimumHoursLabel ? (
                            <span>{minimumHoursLabel}.</span>
                        ) : (
                            <span>
                                The screening date must be at least <strong>
                                    {minimumHours >= 72
                                        ? '72 hours (3 days)'
                                        : minimumHours >= 48
                                        ? '48 hours (2 days)'
                                        : minimumHours === 1
                                        ? '1 hour'
                                        : `${minimumHours} hours`}
                                </strong> from now.
                            </span>
                        )}
                    </Col>
                )}
            </Row>
            <Row>
                {showInvalid && (
                    <Col>
                        <div className="alert alert-danger mt-2 mb-0" style={{ fontSize: '0.875rem' }}>
                            <span className="fas fa-exclamation-circle me-2" />
                            {!isValidDate(screeningDate)
                                ? 'Invalid date format. Please select a valid date.'
                                : `Invalid screening date. Must be at least ${formatDateBy(minimumScreeningDate, 'dd MMM yyyy')} at ${formatTime(minimumScreeningDate)}.`
                            }
                        </div>
                    </Col>
                )}
            </Row>
        </>
    );
};

export default ScreeningDatePicker;
